/** @format */

const isAuth = (state) => state.auth.isAuth

export const signUserSelectors = { isAuth }
